'use client';
import { useEffect, useState } from 'react';
import { isWindowDefined } from '@utils/validations';

export default function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    if (!isWindowDefined) {
      return;
    }

    function checkWindowSize() {
      setIsDesktop(window.innerWidth >= 1024);
    }
    checkWindowSize();

    window.addEventListener('resize', checkWindowSize);

    return () => {
      window.removeEventListener('resize', checkWindowSize);
    };
  }, []);

  return isDesktop;
}
